import { render, staticRenderFns } from "./VoiceEvent.vue?vue&type=template&id=bb9f0500&"
import script from "./VoiceEvent.vue?vue&type=script&lang=js&"
export * from "./VoiceEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports